module.exports = __webpack_public_path__ + "img/todo.29b8b0bd.svg";